import { AppContext } from '@blaze-cms/nextjs-components';
import { useContext, useEffect, useState, useMemo } from 'react';

const useAppEventHook = ({ eventName, data, props }) => {
  const { blazeApp } = useContext(AppContext);
  const hasListener =
    blazeApp && blazeApp.events && blazeApp.events.hasListeners(`plugin:page-builder:${eventName}`);
  const [loading, setLoading] = useState(hasListener);
  const [updatedData, setUpdatedData] = useState(null);

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const stableData = useMemo(() => data, [JSON.stringify(data)]);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  const stableProps = useMemo(() => props, [JSON.stringify(props)]);

  useEffect(() => {
    async function emitEvent() {
      // setLoading(true);
      await blazeApp.events.emitAsync(`plugin:page-builder:${eventName}`, {
        data: updatedData,
        props: stableProps
      });
      setLoading(false);
    }
    if (hasListener && updatedData) emitEvent();
  }, [updatedData, eventName, hasListener, blazeApp.events, stableProps]);

  useEffect(() => {
    setUpdatedData(stableData);
  }, [stableData]);

  return { data: updatedData || stableData, loading };
};
export default useAppEventHook;
